import React, { useState } from "react";
import { Formik, Form } from "formik";

import PageWrapper from "../../../../PageWrapper";
import PrimaryButton from "../../../../SFUCentralThemedComponents/PrimaryButton";
import Label from "../../../../Label";
import DropdownWithInput from "../../../../GenericFormikComponents/DropdownWithInput";
import AutoSave from "../../../../../utils/formik/AutoSave";
import ProgressSpinnerPR from "../../../../PrimeReact/ProgressSpinnerPR";

import { validationSchema, initialValues } from "./validationSchema";

export default function ContactMethodPage({
  goToPage,
  pageInfo,
  scholarshipAppData,
  scholarshipAppOptions,
  savePage,
  saveField,
  saveFieldStatus,
  steppers,
  spinnerStatus,
}) {
  const [formikInitialErrors] = useState({});
  const [formikInitialTouched] = useState({});
  const [lastSaved, setLastSaved] = useState("");

  const contactMethodName = `fieldValue_${scholarshipAppData.data.fields.contactMethod.scholarship_application_fields_id}`;
  const contactMethodInputName = `fieldValue_${scholarshipAppData.data.fields.contactMethodInput.scholarship_application_fields_id}`;

  return (
    <PageWrapper>
      {steppers(pageInfo.pageNum)}
      <Formik
        initialValues={
          scholarshipAppData.isLoading
            ? initialValues(contactMethodName, contactMethodInputName)
            : scholarshipAppData.data
        }
        initialErrors={formikInitialErrors}
        initialTouched={formikInitialTouched}
        validationSchema={validationSchema(
          contactMethodName,
          contactMethodInputName
        )}
        onSubmit={(values) => {
          savePage(values);
          goToPage(pageInfo.pageNum + 1);
          window.scrollTo(0, 0);
        }}
        enableReinitialize
      >
        {() => (
          <Form>
            {!spinnerStatus ? (
              <AutoSave
                savedFields={Object.keys(
                  initialValues(contactMethodName, contactMethodInputName)
                )}
                saveField={saveField}
                saveFieldStatus={saveFieldStatus}
                setLastSaved={setLastSaved}
              />
            ) : (
              ""
            )}
            <div className="p-grid">
              <div className="p-col-12">
                <h1>Confirmation of Contact Information</h1>
              </div>
              <div className="p-col-12">
                <p>
                  As part of the application adjudication process we may need to
                  contact you to confirm details, or inform short listed
                  candidates how to complete the next part of the application
                  process.
                </p>
                <Label htmlFor={contactMethodName}>
                  <span>Preferred Contact Method</span>
                  <DropdownWithInput
                    id="contactMethod"
                    name={contactMethodName}
                    placeholder="Select Contact Method"
                    options={scholarshipAppOptions.data.contactMethods}
                    inputMap={{
                      Phone: "Enter Phone Number",
                      Email: "Enter Preferred Email Address",
                      Other: "Enter Contact Method",
                    }}
                    inputName={contactMethodInputName}
                  />
                </Label>
              </div>
              <div className="p-col-12">
                <span className="last-saved">
                  <em>{lastSaved}</em>
                </span>
              </div>
            </div>
            <div className="p-grid button-navigation-container">
              <div className="p-col-12">
                <PrimaryButton
                  type="button"
                  disabled={spinnerStatus}
                  onClick={() => {
                    goToPage(pageInfo.pageNum - 1);
                  }}
                >
                  Back
                </PrimaryButton>
                <PrimaryButton
                  type="submit"
                  className="push-right"
                  disabled={spinnerStatus}
                >
                  Next
                </PrimaryButton>
              </div>
            </div>
          </Form>
        )}
      </Formik>
      {spinnerStatus ? <ProgressSpinnerPR /> : ""}
    </PageWrapper>
  );
}
